var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 216,
    viewBox: "0 0 217 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.486 102.224C109.647 115.301 101.582 131.07 97.5067 141.549C96.9561 142.965 95.5727 143.879 94.0544 143.832C92.5361 143.784 91.2129 142.784 90.7523 141.337C88.7659 135.094 84.473 125.662 78.1677 117.869C71.8273 110.032 63.9359 104.417 54.7503 104.417C52.7713 104.417 51.167 102.812 51.167 100.833C51.167 98.8544 52.7713 97.2501 54.7503 97.2501C67.0647 97.2501 76.7914 104.774 83.7392 113.361C88.2496 118.935 91.7932 125.197 94.3284 130.79C99.0474 120.662 106.101 108.35 114.969 97.6508C126.304 83.9754 141.256 72.1667 158.667 72.1667C160.646 72.1667 162.25 73.7711 162.25 75.7501C162.25 77.7291 160.646 79.3334 158.667 79.3334C144.544 79.3334 131.427 89.0248 120.486 102.224Z",
    fill: "#3C563E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 215,
    height: 215,
    rx: 107.5,
    stroke: "#3C563E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.ed02c8b289b4eedc44bcb5e193d6e986.svg";
export { ForwardRef as ReactComponent };